// SPA bootstrap. Mounts <App /> into <div id="root"> inside index.html.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Self-hosted variable fonts. These register the 'DM Sans Variable' and
// 'JetBrains Mono Variable' families that the --font-sans / --font-mono
// tokens in globals.css reference; import them before the stylesheet so
// the @font-face rules precede first paint.
import '@fontsource/bebas-neue/latin-400.css'
import '@fontsource-variable/dm-sans'
import '@fontsource-variable/jetbrains-mono'
import './styles/globals.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
